import { CURRENCIES } from '../../config';

export class CurrencyFormatter {
  private static formatNumber(number: number, config: Intl.NumberFormatOptions): string {
    return new Intl.NumberFormat('ru-RU', config).format(number);
  }

  private static replaceNonBreakingSpaces(str: string): string {
    return str.replace(/\u00A0/g, ' ');
  }

  private static formatFractionPart(number: number, formattedNumber: string): string {
    const [_, fractionPart] = number.toFixed(2).split('.');
    return formattedNumber.replace(/,\d+/, `,${fractionPart}`);
  }

  static formatCurrency(number: number, isFraction = false): string {
    const config: Intl.NumberFormatOptions = {
      style: 'currency',
      currency: CURRENCIES.RUB.CODE,
      minimumFractionDigits: 0,
      maximumFractionDigits: isFraction ? 2 : 0,
    };

    const roundedNumber = isFraction ? number : Math.floor(number);
    const formattedNumber = CurrencyFormatter.replaceNonBreakingSpaces(
      CurrencyFormatter.formatNumber(roundedNumber, config),
    );

    if (isFraction) {
      return CurrencyFormatter.formatFractionPart(number, formattedNumber);
    }

    return formattedNumber;
  }
}
